import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { reduxForm } from 'redux-form/immutable';
import FlatButton from 'material-ui/FlatButton';
import DataTables from 'material-ui-datatables';
import moment from 'moment';

import FontIcon from 'material-ui/FontIcon';
import IconButton from 'material-ui/IconButton';
import _ from 'lodash';

import Loading from '../Common/Loading';
import ReduxDialog from '../Common/ReduxDialog';
import { hideDialog } from '../../actions/dialogs';
import { getDialogContextProp } from '../../reducers/helper';
import { toJSSafe, sortDates, getOrderDirection, contains, sortStrings } from '../../utils/helper';

import styles from './styles';

import { fetchJobs } from '../../actions/jobs';
import { fetchCustomers } from '../../actions/customers';

const getTableColumns = (onSelect) => {
  return _.flatten([
    {
      key: 'reference',
      label: 'Reference',
      render: (reference, job) => reference,
      sortable: true,
      style: styles.referenceCol,
    }, {
      key: 'customer',
      label: 'Customer',
      render: (customer, job) => customer ? customer.name : '',
      sortable: true,
      style: styles.customerCol,
    }, {
      key: 'description',
      label: 'Description',
      render: (description, job) => description,
      style: styles.descriptionCol,
    }, {
      key: 'start',
      label: 'Start',
      render: (start, job) => moment(start).format('ll'),
      sortable: true,
      style: styles.dateCol,
    }, {
      key: 'end',
      label: 'End',
      render: (start, job) => moment(start).format('ll'),
      sortable: true,
      style: styles.dateCol,
    }, {
      key: 'action',
      label: '',
      render: (a, job) => {
        return (<IconButton tooltip="Select" tooltipPosition="bottom-center" onClick={() => onSelect(job)}>
          <FontIcon className="material-icons" style={styles.select}>chevron_right</FontIcon>
        </IconButton>);
      },
      alignRight: true,
      style: styles.actionCol,
    },
  ]);
};

const getSorter = (sorter = (a, b) => 0, order = 'asc') => {
  return (a, b) => {
    let result = sorter(a, b);

    if (result === 0) {
      result = sortDates(a.start, b.start);

      if (result === 0) {
        result = sortDates(a.end, b.end);

        if (result === 0) {
          result = sortStrings(a.id, b.id);
        }
      }
    }

    return result * getOrderDirection(order);
  };
};

const getJobFilter = (filter) => {
  return (job) => {
    if (filter) {
      if (job.reference && contains(job.reference, filter)) {
        return true;
      }
      if (job.customer && contains(job.customer.name, filter)) {
        return true;
      }
      if (job.primaryContact && contains(job.primaryContact.name, filter)) {
        return true;
      }
      if (contains(job.description, filter)) {
        return true;
      }

      return false;
    }

    return true;
  };
};

class FindJob extends Component {
  static propTypes = {
    fetchJobs: PropTypes.func.isRequired,
    fetchCustomers: PropTypes.func.isRequired,

    jobs: PropTypes.array.isRequired,
    customers: PropTypes.array.isRequired,

    loading: PropTypes.bool.isRequired,
    onRequestClose: PropTypes.func,
    hideDialog: PropTypes.func.isRequired,
    onSelect: PropTypes.func,
  };

  state = {
    page: 1,
    limit: 10,
    sortBy: getSorter((a, b) => sortDates(a.start, b.start), 'desc'),
    order: 'asc',
    data: [],
  };

  componentWillMount() {
    this.props.fetchJobs();
    this.props.fetchCustomers();
  }

  componentWillReceiveProps(nextProps) {
    const { sortBy, filter } = this.state;
    this.setState({
      data: nextProps.jobs.filter(getJobFilter(filter ? filter.trim().toLowerCase() : '')).sort(sortBy),
    });
  }

  handleFilterValueChange = (filter) => {
    const {jobs} = this.props;
    const {page, limit, sortBy} = this.state;

    const data = jobs.filter(getJobFilter(filter ? filter.trim().toLowerCase() : '')).sort(sortBy);
    this.setState({
      page: Math.min(page, Math.floor(data.length / limit) + 1),
      data,
    });
  };

  handleSortOrderChange = (key, order) => {
    let sortBy = getSorter();
    switch (key) {
      case 'reference':
        sortBy = getSorter((a, b) => sortStrings(a.reference, b.reference), order);
        break;
      case 'customer':
        sortBy = getSorter((a, b) => sortStrings(a.customer ? a.customer.name : '', b.customer ? b.customer.name : ''), order);
        break;
      case 'primaryContact':
        sortBy = getSorter((a, b) => sortStrings(a.primaryContact ? a.primaryContact.name : '', b.primaryContact ? b.primaryContact.name : ''), order);
        break;
      case 'start':
        sortBy = getSorter((a, b) => sortDates(a.start, b.start), order);
        break;
      case 'end':
        sortBy = getSorter((a, b) => sortDates(a.end, b.end), order);
        break;
      case 'tasks':
        sortBy = getSorter((a, b) => {
          const aCount = (a && a.tasks && a.tasks.count) ? a.tasks.count : 0;
          const bCount = (b && b.tasks && b.tasks.count) ? b.tasks.count : 0;

          return aCount - bCount;
        }, order);
        break;
      case 'created':
        console.log('order',order);
        sortBy = getSorter((a, b) => sortDates(a.created ? a.created.at : new Date(), b.created ? b.created.at : new Date()), order);
        break;
      default:
        break;
    }

    this.setState({
      data: this.state.data.sort(sortBy),
      sortBy,
    });
  };

  handlePreviousPageClick = () => {
    this.setState({
      page: Math.max(1, this.state.page - 1),
    });
  };

  handleNextPageClick = () => {
    const { data, page, limit } = this.state;

    this.setState({
      page: Math.min(Math.ceil(data.length / limit), page + 1),
    });
  };

  handleRowSizeChange = (a, limit) => {
    this.setState({
      limit,
      page: 1,
    });
  };

  handleSelect = (job) => {
    console.log('onSelll', this.props.onSelect);
    const onSelect = this.props.onSelect || _.noop;

    onSelect(job.id);
    this.props.hideDialog('findjob');
  };

  handleSelectCustomer = (customer) => {
    this.setState({
      customer,
    });
  };

  // renderJobs(jobs) {
  //   const { customer } = this.state;
  //   const filteredJobs = jobs.filter((job) => {
  //     if (customer) {
  //       return customer.id === job.customerId;
  //     }
  //
  //     return true;
  //   });
  //
  //   return (<Table selectable={false}>
  //     <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
  //       <TableRow>
  //         <TableHeaderColumn style={styles.customerCol}>Customer</TableHeaderColumn>
  //         <TableHeaderColumn>Description</TableHeaderColumn>
  //         <TableHeaderColumn style={styles.dateCol}>Start</TableHeaderColumn>
  //         <TableHeaderColumn style={styles.dateCol}>End</TableHeaderColumn>
  //         <TableHeaderColumn style={styles.actionCol}></TableHeaderColumn>
  //       </TableRow>
  //     </TableHeader>
  //     <TableBody displayRowCheckbox={false}>
  //       {filteredJobs.length > 0 ? filteredJobs.map(this.renderJob) : this.renderNoData() }
  //     </TableBody>
  //   </Table>);
  // }
  //
  // renderJob = (job) => {
  //   return (<TableRow key={job.id} selectable={false}>
  //     <TableRowColumn style={styles.customerCol}>{job.customer ? job.customer.name : ''}</TableRowColumn>
  //     <TableRowColumn>{job.description}</TableRowColumn>
  //     <TableRowColumn style={styles.dateCol}>{moment(job.start).format('ll')}</TableRowColumn>
  //     <TableRowColumn style={styles.dateCol}>{moment(job.end).format('ll')}</TableRowColumn>
  //     <TableRowColumn style={styles.actionCol}>
  //       <IconButton tooltip="Select" tooltipPosition="bottom-center" onClick={() => this.handleSelect(job)}>
  //         <FontIcon className="material-icons" style={styles.select}>chevron_right</FontIcon>
  //       </IconButton>
  //     </TableRowColumn>
  //   </TableRow>);
  // };
  //
  // renderNoData() {
  //   return (<TableRow key="nodata">
  //     <TableRowColumn colSpan={4} style={styles.noDataRow}>
  //       <FontIcon className="material-icons" style={styles.noData}>transform</FontIcon>
  //       <div>No jobs matching criteria</div>
  //     </TableRowColumn>
  //   </TableRow>);
  // }

  render() {
    const { loading } = this.props;
    const { data, page, limit } = this.state;

    const actions = [
      <FlatButton
        label="Cancel"
        onClick={() => this.props.hideDialog('findjob')}
      />,
    ];

    return (
      <ReduxDialog
        name="findjob"
        title={'Find Job'}
        actions={actions}
        onRequestClose={() => this.props.hideDialog('findjob')}
        bodyStyle={styles.body}
      >
        {/*<form name="findJob" onSubmit={handleSubmit}>*/}
          {/*<div style={styles.tabPage}>*/}
            {/*<div style={commonStyles.row}>*/}
              {/*<AutoComplete*/}
                {/*name="customerId"*/}
                {/*style={commonStyles.input}*/}
                {/*floatingLabelText="Customer"*/}
                {/*floatingLabelFixed*/}
                {/*openOnFocus*/}
                {/*filter={customizedFuzzyFilter}*/}
                {/*dataSource={customers}*/}
                {/*dataSourceConfig={customerDSConfig}*/}
                {/*onNewRequest={this.handleSelectCustomer}*/}
                {/*fullWidth/>*/}
            {/*</div>*/}
          {/*</div>*/}
        {/*</form>*/}
        <div>
          { !loading ? <DataTables
            height={'auto'}
            showRowHover
            columns={getTableColumns(this.handleSelect)}
            data={data.slice((page - 1) * limit, page * limit)}
            onFilterValueChange={this.handleFilterValueChange}
            onSortOrderChange={this.handleSortOrderChange}
            onPreviousPageClick={this.handlePreviousPageClick}
            onNextPageClick={this.handleNextPageClick}
            onRowSizeChange={this.handleRowSizeChange}
            page={page}
            rowSize={limit}
            rowSizeList={[10, 15, 25]}
            count={data.length}
            filterHintText="Filter"
            headerToolbarMode="filter"
            showHeaderToolbar
          /> : <Loading/> }
        </div>
      </ReduxDialog>
    );
  }
}

const form = reduxForm({
  form: 'FindJob',  // a unique identifier for this form
})(FindJob);

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    fetchJobs,
    fetchCustomers,
    hideDialog,
  }, dispatch);
}

function mapStateToProps(state) {
  const jobs = state.get('jobs').get('jobs').toJS().sort((a, b) => sortDates(a.start, b.start));
  const customers = state.get('customers').get('customers').toJS();

  return {
    jobs,
    customers,
    loading: state.get('jobs').get('loading'),
    onSelect: getDialogContextProp(state.get('dialogs').get('dialogs'), 'findjob', 'onSelect'),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(form);



// WEBPACK FOOTER //
// ./src/components/FindJobDialog/index.js